"use client";

import { createDialogStore } from "./FZZ2AVHF.js";
import { createStore, mergeStore, omit, throwOnConflictingProps } from "./BCALMBPZ.js";
import { defaultValue } from "./PBFD2E7P.js";
import { __objRest, __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/popover/popover-store.ts
function createPopoverStore() {
  var _a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _b = _a,
    otherPopover = _b.popover,
    props = __objRest(_b, ["popover"]);
  var store = mergeStore(props.store, omit(otherPopover, ["arrowElement", "anchorElement", "contentElement", "popoverElement", "disclosureElement"]));
  throwOnConflictingProps(props, store);
  var syncState = store == null ? void 0 : store.getState();
  var dialog = createDialogStore(__spreadProps(__spreadValues({}, props), {
    store: store
  }));
  var placement = defaultValue(props.placement, syncState == null ? void 0 : syncState.placement, "bottom");
  var initialState = __spreadProps(__spreadValues({}, dialog.getState()), {
    placement: placement,
    currentPlacement: placement,
    anchorElement: defaultValue(syncState == null ? void 0 : syncState.anchorElement, null),
    popoverElement: defaultValue(syncState == null ? void 0 : syncState.popoverElement, null),
    arrowElement: defaultValue(syncState == null ? void 0 : syncState.arrowElement, null),
    rendered: Symbol("rendered")
  });
  var popover = createStore(initialState, dialog, store);
  return __spreadProps(__spreadValues(__spreadValues({}, dialog), popover), {
    setAnchorElement: function setAnchorElement(element) {
      return popover.setState("anchorElement", element);
    },
    setPopoverElement: function setPopoverElement(element) {
      return popover.setState("popoverElement", element);
    },
    setArrowElement: function setArrowElement(element) {
      return popover.setState("arrowElement", element);
    },
    render: function render() {
      return popover.setState("rendered", Symbol("rendered"));
    }
  });
}
export { createPopoverStore };